import { render, staticRenderFns } from "./RequestTransferProduct.vue?vue&type=template&id=5bd1d289"
import script from "./RequestTransferProduct.vue?vue&type=script&lang=js"
export * from "./RequestTransferProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports